export const LIST_CATEGORIES = '[Categories] List Categories';
export const LIST_CATEGORIES_SUCCESS = '[Categories] List Categories Success';
export const LIST_CATEGORIES_ERROR = '[Categories] List Categories Error';

export const LIST_COUNTRIES = '[Categories] List Countries';
export const LIST_COUNTRIES_SUCCESS = '[Categories] List Countries Success';
export const LIST_COUNTRIES_ERROR = '[Categories] List Countries Error';

export const SEARCH_CATEGORIES = '[Categories] Search Categories';
export const SEARCH_CATEGORIES_SUCCESS = '[Categories] Search Categories Success';
export const SEARCH_CATEGORIES_ERROR = '[Categories] Search Categories Error';